import { CONSTANTS } from '@tpco/tpco-saturn-types';
import cookie from 'react-cookies';
import { P3Campaign } from 'models/interfaces';
import { P3Configuration } from 'models/interfaces/P3Configurations';
import {
  canBeEdited as canBeEditedService,
  canBeOptimized as canBeOptimizedService,
  canBePublished as canBePublishedService,
  p3PoitnsAlgorithm,
  pointsAreValid,
  canAccessLegacyOpportunity,
  hasRegPointsAndCov,
  getLastDayToPublish,
  getThisMonthCutOffDate
} from '@tpco/tpco-saturn-logic';
function getFulfillmentStatus(productFulfillment: any) {
  return getfulfillmentStatusName(
    productFulfillment.thomas_campaign,
    productFulfillment.configuration
  );
}
function getfulfillmentStatusName(campaign: any, configuration: any) {
  if (!campaign) {
    //ToDo: Francia fix this. The problem is that ProductFulfillmentReduced does not have thomas_campaign on it.
    // ¯\_(ツ)_/¯
    return '';
  }
  return CONSTANTS.CAMPAIGN_STATUS_MAP[campaign.status_id];
}
function validateConfiguration(p3Configuration: P3Configuration, p3Campaign: P3Campaign) {
  console.log(`client valid configuration`);
  if (!p3Configuration) {
    console.log(`no p3 configuration`);
    return false;
  }
  if (!p3Campaign) {
    console.log(`no p3 campaing`);
    return false;
  }
  const categories = p3Configuration.categories ? p3Configuration.categories : [];
  const regions = p3Configuration.regions ? p3Configuration.regions : [];
  return (
    pointsAreValid(
      p3Campaign.entitled_rank_points,
      p3Configuration.rank_points,
      p3Configuration.coverage_areas
    ) && hasRegPointsAndCov(categories, regions)
  );
}
function canBeDeleted(campaignStatus: number, opportunityId: string, productId: number) {
  if (canSuperUser()) {
    console.log(`super user canBeDeleted`, true);
    return true;
  }
  if (opportunityId != '') {
    return false;
  }
  if (
    productId === CONSTANTS.CAMPAIGN_PRODUCT_TYPE.PVS &&
    campaignStatus !== CONSTANTS.CAMPAIGN_STATUS.NEW
  ) {
    return false;
  }
  return true;
}

function canBeOptimized(
  campaignStatus: number,
  startDate: string,
  endDate: string,
  opportunityId: string
) {
  if (canSuperUser()) {
    console.log(`super user canBeOptimized`, true);
    return true;
  }
  if (opportunityId === '') {
    console.log('any campaign without opportunityid cannot be optimized');
    return false;
  }
  if (opportunityId != '') {
    if (!canAccessLegacyOpportunity(opportunityId, getUser())) {
      console.log('legacy Campaign, cannot be optimized');
      return false;
    }
  }

  return canBeOptimizedService(campaignStatus, startDate, endDate);
}

function canBePublished(campaignStatus: number, startDate: string, opportunityId: string) {
  if (canSuperUser()) {
    console.log(`super user canBePublished`, true);
    return true;
  }

  if (opportunityId != '') {
    if (!canAccessLegacyOpportunity(opportunityId, getUser())) {
      console.log('legacy Campaign, cannot be published');
      return false;
    }
  }

  return canBePublishedService(campaignStatus, startDate, getUser());
}

function canBeEdited(
  campaignStatus: number,
  startDate: string,
  opportunityId: string,
  orderSource?: string
) {
  console.log('last day', getLastDayToPublish(startDate));
  console.log('cutoff day', getThisMonthCutOffDate());
  if (canSuperUser()) {
    console.log(`super user canBeEdited`, true);
    return true;
  }
  if (opportunityId != '') {
    if (!canAccessLegacyOpportunity(opportunityId, getUser())) {
      console.log('legacy Campaign, cannot be edited');
      return false;
    }
  }
  return canBeEditedService(campaignStatus, startDate, getUser(), orderSource);
}

function getParam(param: any) {
  return new URLSearchParams(window.location.search).get(param);
}
function configurationValidPoints(p3Configuration: P3Configuration) {
  if (!p3Configuration) {
    return 0;
  }
  console.log(`configuration id`, p3Configuration.p3_configuration_id);
  console.log(`rankspoint`, p3Configuration.rank_points);
  return p3PoitnsAlgorithm(p3Configuration.rank_points, p3Configuration.coverage_areas);
}

function canSuperUser() {
  let superUser = localStorage.getItem('strn');
  // cookie.load();
  if (!superUser) {
    return false;
  }
  if (superUser.trim() == '') {
    return false;
  }
  let s = getParam('s');
  if (!s) {
    return false;
  }
  if (s === superUser) {
    console.log(`secret is correct`);
    return true;
  }
  return false;
}
function getUser() {
  let roles = localStorage.getItem('roles');
  if (!roles) {
    return CONSTANTS.USER_TYPE.CTP;
  }
  if (canSuperUser()) {
    return CONSTANTS.USER_TYPE.ADMIN;
  }

  if (roles === 'admin') {
    return CONSTANTS.USER_TYPE.ADMIN;
  }
  return CONSTANTS.USER_TYPE.CTP;
}

export {
  getFulfillmentStatus,
  getfulfillmentStatusName,
  validateConfiguration,
  canBeEdited,
  canBeOptimized,
  canBeDeleted,
  canBePublished,
  configurationValidPoints,
  canSuperUser
};
